import { AxiosRequestConfig } from "axios";
import FreespinRequestBuilder from "slotworks/integration/revolver/builders/requests/freespin-request-builder";
import PickRequestBuilder from "slotworks/integration/revolver/builders/requests/pick-request-builder";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import { default as RevolverModel, default as revolverModel } from "slotworks/integration/revolver/model/revolver-model";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import SlotDefinition from "slotworks/model/slot-definition";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import WrapperMediator from "slotworks/integration/revolver/wrapper/wrapper-mediator";

class SpinRequestBuilder implements RequestBuilder {

    public force: string;
    public customStops: string[][];

    public filter(data: any): boolean {
        return data instanceof SpinRequestPayload;
    }

    public build(gameplay: Gameplay, data: any) {
        const spinRequestPayload = data as SpinRequestPayload;

        const totalBet = 200;
        WrapperMediator.roundStart(totalBet, gameplay.balance);
        

        // Revolver take the index of the value in the array (but not 0 indexed) instead of the value
        const coinLevel = SlotDefinition.coinSizes.indexOf(spinRequestPayload.coinSize) + 1;

        const action: any = {
            bet: {bet_level: spinRequestPayload.stakePerLine / revolverModel.creditBaseMultiplier, coin_level: coinLevel, lines: spinRequestPayload.lines.length}
        };

        const freespins = CampaignsModel.freespins;
        if (CampaignsModel.isFreespinsActive()) {
            action.availableCampaignDetails = {
                type: freespins.type,
                awardId: freespins.awardId
            }
        }

        if (this.force) {
            action.force = this.force;
            this.force = null;
            FreespinRequestBuilder.force = null;
            PickRequestBuilder.force = null;
        }
        if (this.customStops) {
            action.customForce = this.customStops;
            this.customStops = null;
        }

        const requestConfig = {
            method: "post",
            url: RevolverModel.getBaseURL(),
            withCredentials: true,
            data: JSON.stringify({
                cmd: "RESULTS",
                session: RevolverModel.session,
                action
            })
        } as AxiosRequestConfig;

        if (RevolverModel.jwt_token) {
            requestConfig['headers'] = {
                "X-RGS-SESSION-TOKEN": RevolverModel.jwt_token
            }
        }

        return requestConfig;

    }
}

export default new SpinRequestBuilder();



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/builders/requests/spin-request-builder.ts